{
  "admin": {
    "title": "Админ",
    "dashboard": "Табло",
    "clientsManagement": "Управление на тенанти",
    "usersManagement": "Управление на потребители",
    "conversationOverview": "Преглед на разговори",
    "aiManagement": "AI управление",
    "globalLogs": "Глобални логове",
    "globalSettings": "Глобални настройки"
  },
  "manage": {
    "title": "Мениджър",
    "dashboard": "Табло",
    "calendar": "Календар",
    "tasksProjects": "Задачи и проекти",
    "knowledgeHub": "База знания",
    "videoMeetings": "Видео срещи",
    "communicationThreads": "Комуникационни нишки",
    "leads": "Лийдове",
    "customers": "Клиенти",
    "reminders": "Напомняния",
    "customersLeads": "Клиенти и лийдове",
    "aiModules": "AI автоматизационни модули",
    "myCompany": "Моята компания",
    "resources": "Ресурси",
    "services": "Услуги",
    "employees": "Служители",
    "companiesAndEmployees": "Компании / Служители",
    "settings": "Настройки",
    "booking": "Резервации",
    "shop": "Магазин",
    "permissions": "Права за достъп",
    "externalModules": "Външни модули",
    "helpers": "Помощници"
  },
  "client": {
    "title": "Клиент",
    "dashboard": "Табло",
    "myCalendar": "Моят календар",
    "communications": "Комуникации",
    "myProfile": "Моят профил"
  }
}
